var $ = require('../internals/export');

var getCompositeKeyNode = require('../internals/composite-key');

var getBuiltIn = require('../internals/get-built-in');

var create = require('../internals/object-create');

var initializer = function initializer() {
  var freeze = getBuiltIn('Object', 'freeze');
  return freeze ? freeze(create(null)) : create(null);
}; // https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey


$({
  global: true
}, {
  compositeKey: function compositeKey() {
    return getCompositeKeyNode.apply(Object, arguments).get('object', initializer);
  }
});